<template>
  <RadioGroup :value="value" type="button" class="sl-radio-tag" @on-change="handleChange">
    <Radio :label="item.value" v-for="item in values">{{item.label}}</Radio>
  </RadioGroup>
</template>
<script>
export default {
  props: {
    field:{
      type:String
    },
    values:{
      type:Array
    },
    value:null
  },

  methods:{
    handleChange(v){
      let hit = this.values.find(i => i.value == v)
      if(hit){
        this.$emit('change',this.field , v , hit.label)
      }
    }
  }
}

</script>
